<script>
    import { entities } from "../../utils/NotificationStrings";
    import { fields } from "../../utils/NotificationStrings";
    import { formatField } from "../../utils/NotificationStrings";

    export let content = {};

    let fieldsLength = 0;
    let maxIndex = 0;

    $: {
        fieldsLength = Object.keys(content.fields).length;
        maxIndex = fieldsLength - 1;
    }
</script>

{#if "archived" in content.fields}
    <p class="text-sm">
        <b>{content.user.name}</b>
        {#if content.fields.archived}
            archived
        {:else}
            unarchived
        {/if}
        the {entities[content.entity.type]}
    </p>
{:else}
    <p class="text-sm">
        <b>{content.user.name}</b>

        changed

        {entities[content.entity.type]}

        {#each Object.entries(content.fields) as [key, value], index}
            {#if index > 0 && index < maxIndex && fieldsLength > 2}
                &nbsp;,
            {:else if index === maxIndex && fieldsLength > 1}
                &nbsp;and
            {/if}

            {fields[key]} to "{formatField(key, value)}"
        {/each}
    </p>
{/if}

<p class="parent-entity">
    {content.entity.name}
</p>

<style>
    .parent-entity {
        @apply text-xs text-gray-400;
    }
</style>
